import { Component, OnInit } from '@angular/core';
import { QuestionComponent } from '../question-component';
import { AutoScoreQuestion } from '../../../../job-service/service-models/AutoScoreQuestion';
import { Choice } from '../../../../job-service/service-models/Choice';
import { Answer } from '../../../../applicant-service/service-models/Answer';

@Component({
  selector: 'app-auto-score',
  templateUrl: './auto-score.component.html',
  styleUrls: ['./auto-score.component.scss']
})
export class AutoScoreComponent extends QuestionComponent<AutoScoreQuestion> implements OnInit {
  ngOnInit() {
    this.question = this.question || new AutoScoreQuestion();

    if (this.question.choices) {
      this.question.choices = this.question.choices.sort((a, b) => a.value === 'yes' ? -1 : 1);
    }

    if (this.question.answers === undefined) {
      this.question.answers = [new Answer()];
    }
  }

  onChoiceChange(choice: Choice) {
    const answer = this.question.answers[0];
    answer.questionId = this.question.id;
    answer.choiceId = choice.id;
    answer.questionVersion = this.question.version;
    answer.value = choice.value;

    this.questionAnswered();
  }
}
